import { asset } from "@/lib/asset";
import ul from '../../assets/icons/ul.svg';

export const KA = () => {
    return (

        <div className="w-full h-auto xl:h-[680px] relative">
            <div className="h-auto xl:h-[655px] left-0 top-0 absolute flex-col justify-start items-center gap-10 inline-flex">

                <div className="w-full xl:w-[1370px] h-auto xl:h-[745px] flex-col justify-between items-center gap-5 flex">

                    <div className="w-full justify-center items-center gap-2 xl:gap-[100px] inline-flex">
                        <div className="w-full xl:w-[384px] text-white text-base font-normal font-['Open Sans']">
                            Компоненты системы настраиваются автоматически безизменения конфигурации или кода,а возможность наблюдения заданными начинается немедленно.
                            <br />Для удобства сопровождения
                        </div>
                        <div className="w-full xl:w-[384px] text-white text-right font-normal font-['Open Sans']">
                            Компоненты системы настраиваются автоматически безизменения конфигурации или кода,а возможность наблюдения заданными начинается немедленно.
                            <br />Для удобства сопровождения
                        </div>
                    </div>

                    <div className="justify-start items-start gap-2 xl:gap-[500px] inline-flex">
                        <div className="text-white text-base font-normal font-['Open Sans']">
                            Компоненты системы настраиваются автоматически безизменения конфигурации или кода,а возможность наблюдения заданными начинается немедленно.
                            <br />Для удобства сопровождения
                        </div>

                        <div className="text-white text-right font-normal font-['Open Sans']">
                            Компоненты системы настраиваются автоматически безизменения конфигурации или кода,а возможность наблюдения заданными начинается немедленно.
                            <br />Для удобства сопровождения
                        </div>
                    </div>

                    <div className="justify-start items-start gap-2 xl:gap-[500px] inline-flex">
                        <div className="text-white text-base font-normal font-['Open Sans']">
                            Компоненты системы настраиваются автоматически безизменения конфигурации или кода,а возможность наблюдения заданными начинается немедленно.
                            <br />Для удобства сопровождения
                        </div>
                        <div className="text-white text-right font-normal font-['Open Sans']">
                            Компоненты системы настраиваются автоматически безизменения конфигурации или кода,а возможность наблюдения заданными начинается немедленно.
                            <br />Для удобства сопровождения
                        </div>
                    </div>
                    
    
                    <div className="w-full xl:w-[1120px] relative flex items-center justify-center">
                        {/* top left bullet  */}
                        <img src={ul} alt="ul" className='w-full xl:w-[38px] h-auto xl:h-[20px] absolute top-[-580px] left-0 xl:left-[40px] object-contain ' />
                        {/* first left horizontal line  */}
                        <div className="absolute top-[-570px] w-full xl:w-[40px] left-0 h-auto xl:h-[1px] bg-[#ffd38e]" />
                        {/* top right bullet  */}
                        <img src={ul} alt="ul" className='w-full xl:w-[38px] h-auto xl:h-[20px] absolute top-[-580px] right-0 xl:right-[40px] object-contain transform -rotate-180' />
                        {/* first right horizontal line  */}
                        <div className="absolute top-[-570px] w-full xl:w-[40px] right-0 h-auto xl:h-[1px] bg-[#ffd38e]" />

                        {/* first left vertical line  */}
                        <div className="absolute top-[-570px] w-full xl:w-[1px] left-0 h-auto xl:h-[70px] bg-[#ffd38e]" />
                        {/* second right vertical line  */}
                        <div className="absolute top-[-570px] w-full xl:w-[1px] right-0 h-auto xl:h-[70px] bg-[#ffd38e]" />



                        {/* top horizontal line  */}
                        <div className="absolute top-[-500px] w-full h-auto xl:h-[1px] bg-[#ffd38e]" />
                        {/* bottom horizontal line  */}
                        <div className="absolute top-0 xl:top-[330px] w-full h-auto xl:h-[1px] bg-[#ffd38e]" />


                        {/* second left horizontal line  */}
                        <div className="absolute top-[-400px] w-full xl:w-[60px] left-0 xl:left-[400px] h-auto xl:h-[1px] bg-[#ffd38e]" />
                        {/* second right horizontal line  */}
                        <div className="absolute top-[-400px] w-full xl:w-[60px] right-0 xl:right-[420px] h-auto xl:h-[1px] bg-[#ffd38e]" />


                        {/* third left horizontal line  */}
                        <div className="absolute top-[-260px] w-full xl:w-[340px] left-0 xl:left-[60px] h-auto xl:h-[1px] bg-[#ffd38e]" />
                        {/* third right horizontal line  */}
                        <div className="absolute top-[-260px] w-full xl:w-[367px] right-0 xl:right-[53px] h-auto xl:h-[1px] bg-[#ffd38e]" />
                        {/* third left vertical line  */}
                        <div className="absolute top-[-280px] w-full xl:w-[1px] left-0 xl:left-[60px] h-auto xl:h-[20px] bg-[#ffd38e]" />
                        {/* third right vertical line  */}
                        <div className="absolute top-[-280px] w-full xl:w-[1px] right-0 xl:right-[53px] h-auto xl:h-[20px] bg-[#ffd38e]" />
                        {/* middle right bullet  */}
                        <img src={ul} alt="ul" className='w-full xl:w-[38px] h-auto xl:h-[20px] absolute top-[-310px] right-0 xl:right-[35px] object-contain transform -rotate-90' />
                        {/* middle left bullet  */}
                        <img src={ul} alt="ul" className='w-full xl:w-[38px] h-auto xl:h-[20px] absolute top-[-310px] left-0 xl:left-[42px] object-contain transform rotate-[-90deg]' />

                        {/* top vertical line  */}
                        <div className="absolute top-[-500px] w-full xl:w-[1px] h-auto xl:h-[40px] bg-[#ffd38e]" />

                        {/* logo */}
                        <img src={asset("/img/ka.svg")} alt="ka" className='w-full xl:w-[166px] h-auto xl:h-[110px] top-[-450px] absolute object-contain' />


                        {/* bottom central vertical line  */}
                        <div className="absolute top-[-320px] w-full xl:w-[1px] h-auto xl:h-[280px] bg-[#ffd38e]" />
                        <img src={ul} alt="ul" className='w-full xl:w-[38px] h-auto xl:h-[20px] absolute top-[-40px] object-contain transform rotate-[90deg]' />
                        {/* bottom left vertical line  */}
                        <div className="absolute top-[-400px] w-full xl:w-[1px] h-auto xl:h-[380px] left-0 xl:left-[400px] bg-[#ffd38e]" />
                        {/* bottom right vertical line  */}
                        <div className="absolute top-[-400px] w-full xl:w-[1px] h-auto xl:h-[380px] right-0 xl:right-[420px] bg-[#ffd38e]" />

                        {/* bottom left horizontal line  */}
                        <div className="absolute top-[-20px] w-full xl:w-[335px] left-0 xl:left-[65px] h-auto xl:h-[1px] bg-[#ffd38e]" />
                        {/* bottom right horizontal line  */}
                        <div className="absolute top-[-20px] w-full xl:w-[360px] right-0 xl:right-[61px] h-auto xl:h-[1px] bg-[#ffd38e]" />
                        
                        {/* bottom left vertical line  */}
                        <div className="absolute top-[-40px] w-full xl:w-[1px] left-0 xl:left-[65px] h-auto xl:h-[20px] bg-[#ffd38e]" />
                        {/* bottom right vertical line  */}
                        <div className="absolute top-[-40px] w-full xl:w-[1px] right-0 xl:right-[61px] h-auto xl:h-[20px] bg-[#ffd38e]" />
                        {/* bottom right bullet  */}
                        <img src={ul} alt="ul" className='w-full xl:w-[38px] h-auto xl:h-[20px] absolute top-[-70px] right-0 xl:right-[44px] object-contain transform -rotate-90' />
                        {/* bottom left bullet  */}
                        <img src={ul} alt="ul" className='w-full xl:w-[38px] h-auto xl:h-[20px] absolute top-[-70px] left-0 xl:left-[46px] object-contain transform rotate-[-90deg]' />


                        <div className="justify-start items-start gap-2 xl:gap-[500px] inline-flex absolute top-[-5px]">
                            <div className="w-full xl:w-[186px] h-auto xl:h-[38px] text-center text-white text-base font-normal font-['Open Sans']">
                            Мониторинга работы приложений в реальном времени.
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    );
};

export default KA;